import { WebAuth, RedirectParseError } from '@chehejia/authli-js'
const auth = new WebAuth({ 
   clientId: '4jOebOvHeGaVRJ9mzxuqfb',
   env: 'ontest', // 支持 ontest prod
   host: 'https://id-ontest.lixiang.com',
   redirectUri: window.location.href
})
// 授权之后，获取服务token
function getToken () {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await auth.getToken({
        audience: '1sBE38DZKVwwpRQ5FV27bM',
        force: true
      }) || '';
      token && localStorage.setItem("id-token", token);
      resolve(token)
    } catch (error) {
      console.log(error);
      reject(false)
    }
  })
}
const IdaasLogin = async() => {
  try {
    await auth.logout();
    await auth.handleRedirectCallback();
  } catch (error) {
    if (error instanceof RedirectParseError) {
      await auth
        .authorize({
          requestLogin: true,
          multiAudience: {
            '1sBE38DZKVwwpRQ5FV27bM': {
              scope: 'read'
            },
          },
          redirectUri: window.location.href,
        })
        .catch(error => {
          console.log(error);
        });
      const res = await auth.getUser();
      localStorage.setItem("idaasUserInfo", JSON.stringify(res));
      getToken();
    } else {
      console.log(error);
    }
  }}


  function initZeus(simpleUserVo: any) {
    try {
      // @ts-ignore
      const zeus = new window.ZEUS({
        appid: 'fed-web-club', // 【必传】
        env: window.location.href.includes('editor.lixiang.com') ? 'prod' : 'test', // 【必传】环境，非prod日志均存储到test服务，默认‘test’
        uvKey: () => `${simpleUserVo.nickname}_${simpleUserVo.aud}`, // 【uv统计必传】获取用户唯一ID，不要用用户中文名，可能导致uid重复     // 【部门统计3选1必传】理想员工域账号，示例
        liEmplId: simpleUserVo.aud, // 【部门统计3选1必传】理想员工工号（sdk > 0.20.0）     // 【部门统计3选1必传，仅支持生产环境】员工 idaas openid 账号（sdk > 0.20.0）
      });
      window.zeus = zeus;
    } catch (error) {
      console.log('initZeus error', error);
    }
  }
export {auth, IdaasLogin, getToken,initZeus}